import { ILoginOIDCRequest } from '../models/request/account/ILoginOIDCRequest';
import { apiClient } from './apiClient';
import { apiGuestClient } from './apiGuestClient';

const accountApi = {
    getUser: () => {
        return apiClient.get(`account/info`)
    },
    logInSSO: (data: ILoginOIDCRequest) => {
        return apiGuestClient.post(`account/login-oidc`, data)
    },
    logOut() {
        return apiClient.post(`account/logout`, undefined, localStorage.getItem("homeURL") ?? "")
    }
}
export { accountApi };